import { ValidationHistoryPartialStoreState, VALIDATION_HISTORY_STATE_KEY } from './validation-history.reducer';

export const getValidations = (state: ValidationHistoryPartialStoreState) =>
    state[VALIDATION_HISTORY_STATE_KEY].validations;

export const getLoading = (state: ValidationHistoryPartialStoreState) => state[VALIDATION_HISTORY_STATE_KEY].loading;

export const getStartDate = (state: ValidationHistoryPartialStoreState) =>
    state[VALIDATION_HISTORY_STATE_KEY].startDate;

export const getEndDate = (state: ValidationHistoryPartialStoreState) => state[VALIDATION_HISTORY_STATE_KEY].endDate;

export const getMaxStartDate = (state: ValidationHistoryPartialStoreState) =>
    state[VALIDATION_HISTORY_STATE_KEY].maxStartDate;

export const getMaxEndDate = (state: ValidationHistoryPartialStoreState) =>
    state[VALIDATION_HISTORY_STATE_KEY].maxEndDate;

export const getMinStartDate = (state: ValidationHistoryPartialStoreState) =>
    state[VALIDATION_HISTORY_STATE_KEY].minStartDate;

export const getMinEndDate = (state: ValidationHistoryPartialStoreState) =>
    state[VALIDATION_HISTORY_STATE_KEY].minEndDate;

export const getDateDiff = (state: ValidationHistoryPartialStoreState) => state[VALIDATION_HISTORY_STATE_KEY].diff;
